import type { Action } from './actions'
import type { MetaShortDTO, PointsPage } from 'shared/types'
import endpoints from 'shared/store/endpoints'
import { managePageAPIError } from 'shared/store/utils'

export type State = PointsPage & {
    showTuto: boolean,
    transformPointsError?: string,
    pointsError?: any,
    pointsNetworkError?: any,
    nbCoupons?: number,
    dataLoaded: boolean,
    metaData?: MetaShortDTO
}

const initialState: State = {
    levels: [],
    showTuto: false,
    dataLoaded: false,
    pointInfos: {
        currentLevelIndex: 0,
        expirationDate: '',
        nbLevels: 5,
        points: 0
    }
}

export const reducer = (state: State = initialState, action: Action): State => {
    switch (action.type) {
        case 'PAGE_DATA_DASHBOARD_RESPONSE':
            return {
                ...state,
                pointInfos: action.data.pointInfos
            }
        case 'PAGE_DATA_PRIVILEGES_RESPONSE':
            return {
                ...state,
                nbCoupons: action.data.coupons.length
            }
        case 'PAGE_DATA_POINTS_RESPONSE':
            return {
                ...state,
                ...action.data,
                dataLoaded: true,
                showTuto: false,
                pointsError: undefined,
                pointsNetworkError: undefined
            }
        case 'TRANSFORM_POINTS_SUCCESS':
            return {
                ...state,
                pointInfos: action.pointInfos,
                transformPointsError: undefined
            }
        case 'TRANSFORM_POINTS_ERROR':
            return {
                ...state,
                transformPointsError: action.transformPointsError
            }
        case 'UNTRANSFORM_POINTS_SUCCESS':
            return {
                ...state,
                pointInfos: action.pointInfos
            }
        case 'RESET_TRANSFORM_POINTS':
            return {
                ...state,
                transformPointsError: undefined
            }
        case 'UPDATE_POINTS':
            return {
                ...state,
                pointInfos: action.pointInfos
            }
        case 'PAGE_DATA_HOMEPAGE_RESPONSE':
            return {
                ...state,
                pointInfos: action.data.pointInfos
            }
        case 'PAGE_DATA_ROOT_RESPONSE':
            const { homePage } = action.data
            return {
                ...state,
                pointInfos: homePage ? homePage.pointInfos : state.pointInfos
            }
        case 'PRIVILEGES_ADD_COUPON_SUCCESS':
            const { pointInfos } = action
            if (!!pointInfos) {
                return {
                    ...state,
                    pointInfos
                }
            } else {
                return state
            }
        case 'LOGOUT':
            return {
                ...initialState,
                showTuto: state.showTuto
            }
        case 'PAGE_API_ERROR':
            return managePageAPIError(
                state,
                action,
                endpoints.kingdom.points.page,
                'pointsError'
            )
        case 'PAGE_API_AUTH_ERROR':
            return {
                ...state,
                pointsError: action.error
            }
        case 'RESET_NETWORK_ERROR':
            return {
                ...state,
                pointsNetworkError: undefined
            }
        case 'PAGE_NETWORK_ERROR':
            return {
                ...state,
                pointsNetworkError: action.networkError,
                pointsError: undefined
            }
        default:
            return state
    }
}
